import TopNavBar from "../TopNavBar/TopNavBar";
import {
  Accordion,
  AccordionItem,
  Icon,
  Logo,
  NavLink,
  SideNavigationContent,
  SideNavigationPageContent,
  SideNavigationWrapper,
  Typography,
  SideNavigation,
} from "cfa-react-components";
import { Col, Row } from "reactstrap";
import "./RiskAnalysis.scss";
import {
  NavLink as ReactRouterNavLink,
  MemoryRouter,
  Switch,
  Route,
} from "react-router-dom";
import React, { useState } from "react";
import RiskAnalysisAccordionDropdown from "./RiskAnalysisAccordionDropdown";
import Sherlock from "./Sherlock/sherlock";
import ExcessiveActivityReport from "./ExcessiveActivityReport/ExcessiveActivityReport";

function RiskAnalysis() {
  const [selectedComponent, setSelectedComponent] = useState("info");

  const selectTable = (comp: string) => {
    setSelectedComponent(comp);
  };
  function componentSwitch() {
    if (selectedComponent == "info") {
      return <Sherlock />;
    } else if (selectedComponent == "deposit") {
      return <ExcessiveActivityReport />;
    }
  }

  return (
    <>
      <Col className="BankAccountMGMT container">
        <Row className={"headerRow"}>
          <Col>
            <TopNavBar />
          </Col>
        </Row>
        <Row>
          <Col md={2}>
            <MemoryRouter initialEntries={["/reporting"]}>
              <SideNavigationWrapper>
                <SideNavigation
                  className={"SideNavigation"}
                  color={"secondary"}
                  elevation={2}
                  style={{
                    width: "3%",
                    marginTop: "4.5em",
                  }}
                >
                  <SideNavigationContent
                    section={"middle"}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginBottom: "16px",
                      marginRight: "3px",
                    }}
                  >
                    <Logo color="tertiary" logo="symbol" size={"sm"} />
                  </SideNavigationContent>
                  <SideNavigationContent
                    section={"middle"}
                    style={{
                      justifyContent: "center",
                    }}
                  >
                    <NavLink
                      aria-label="Navigate to reporting"
                      variant="sidenavigation-link"
                      //@ts-ignore
                      icon={<Icon icon={"report-search"} size={"md"} />}
                      as={ReactRouterNavLink}
                      to={"reporting"}
                    ></NavLink>
                  </SideNavigationContent>
                </SideNavigation>
                <SideNavigationPageContent as={"div"}>
                  <RiskAnalysisAccordionDropdown compSwitch={selectTable} />
                  {/*<Switch>
                    <Route path="/">
                      <Route component={ReportingAccordionDropdown} path="/reporting" />
                      <Route
                        component={ReportingAccordionDropdown }
                        path="/bankInformation"
                      />
                      <Route
                        component={AccordionDropdown}
                        path="/depositoryAssignments"
                      />
                      <Route
                        component={AccordionDropdown}
                        path="/parentAccounts"
                      />
                      <Route
                        component={AccordionDropdown}
                        path="/disbursementAccounts"
                      />
                      <Route path="*" />
                    </Route>
                  </Switch>*/}
                </SideNavigationPageContent>
              </SideNavigationWrapper>
            </MemoryRouter>
          </Col>
          <Col>{componentSwitch()}</Col>
        </Row>
      </Col>
    </>
  );
}
export default RiskAnalysis;
